'use es6';

import { getSurveys, createGetSurveys } from 'reference-resolvers/api/SurveyMonkeyApi';
import * as CacheKeys from 'reference-resolvers/constants/CacheKeys';
import createSimpleCachedReferenceResolver from 'reference-resolvers/lib/createSimpleCachedReferenceResolver';
export const createSurveyReferenceResolver = options => createSimpleCachedReferenceResolver(Object.assign({
  cacheKey: CacheKeys.SURVEYS,
  createFetchData: createGetSurveys,
  fetchData: getSurveys
}, options));
export default createSurveyReferenceResolver();